export default "__VITE_ASSET__c4ae34d7__"